import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React from 'react';
import fieldLogic from '../logic/fieldsLogic';
import MaskedText from '../controls/MaskedText';
import useInputRef from './useInputRef';
import Typography from '@material-ui/core/Typography';
import LookupButton from '../components/LookupButton';
import StyledText from './StyledTextInput';
import helpers from '../utils/fieldsHelper';
import Utils from '../../../../utils';
/**
 * @param {import('../components/types').FormFieldTextBoxProps} props
 */

var FormFieldText = function FormFieldText(props) {
  var description = props.description,
      placeholder = props.placeholder,
      error = props.error,
      readonly = props.readonly;
  var value = props.value,
      active = props.active,
      fieldId = props.fieldId,
      dispatch = props.dispatch;
  var mask = props.mask,
      type = props.type,
      variant = props.variant;
  var min = props.min,
      max = props.max,
      maxCharacters = props.maxCharacters;
  var lookupVisiblity = props.lookupVisiblity,
      xpath = props.xpath;

  var _useInputRef = useInputRef(active),
      _useInputRef2 = _slicedToArray(_useInputRef, 1),
      inputRef = _useInputRef2[0];

  var onChange = function onChange(event) {
    var value = event.target.value;
    var charsLimitReached = value && maxCharacters && value.length > maxCharacters;
    if (!charsLimitReached) fieldLogic.onChange(fieldId, value, dispatch);
  };

  var onFocus = function onFocus() {
    return fieldLogic.onFocus(fieldId, dispatch);
  };

  var onBlur = function onBlur() {
    return fieldLogic.onBlur(fieldId, dispatch);
  };

  var hasError = !!error;
  var showLookupButton = xpath && lookupVisiblity !== 'hide';
  var InputProps = {
    endAdornment: showLookupButton ? React.createElement(LookupButton, {
      fieldId: fieldId
    }) : null
  };
  if (type === 'textbox' && mask) InputProps.inputComponent = MaskedText;
  var descriptionContent = description ? React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: helpers.getHtmlMarkup(description)
    }
  }) : '';
  var inputProps = {
    mask: mask
  };

  if (type === 'number') {
    if (!Number.isNaN(max)) inputProps.max = max;
    if (!Number.isNaN(min)) inputProps.min = min;
  }

  return React.createElement(StyledText, {
    InputProps: InputProps,
    inputProps: inputProps,
    error: hasError,
    helperText: error || descriptionContent || React.createElement(Typography, null, " "),
    placeholder: placeholder || mask,
    disabled: readonly,
    value: value || '',
    variant: variant,
    type: type,
    inputRef: inputRef,
    onBlur: onBlur,
    onFocus: onFocus,
    onChange: onChange
  });
};

export default React.memo(FormFieldText, function (prevProps, nextProps) {
  return Utils.deepEqual(prevProps, nextProps);
});